<template>
  <div
    :class="wrapperClasses"
    class="members-rates-activity"
  >
    <div class="d-flex justify-content-between align-items-center">
      <h4>{{ title }} history</h4>
      <img
        :src="hubstaffBetaImage"
        alt="Hubstaff People Beta"
      />
    </div>
    <div class="table-wrapper">
      <div class="scrollable">
        <AppTable
          :table-data="activityData"
          :loading="members_rates_loading"
          table-classes="table-striped"
          hoverable
        >
          <template #empty>
            <div class="my-20">No data available</div>
          </template>
          <AppTableColumn
            v-slot="{ row }"
            header="Status"
          >
            {{ row.status }}
            <i
              v-if="isScheduled(row.status) && canDelete"
              v-tooltip
              title="Remove"
              class="hi hi-delete action-icon"
              @click="removeItem(row)"
            ></i>
          </AppTableColumn>
          <AppTableColumn
            v-slot="{ row }"
            :visible="!isBillRate"
            header="Pay period"
          >
            {{ columnInformation(payPeriod(row.pay_period)) }}
          </AppTableColumn>
          <AppTableColumn
            v-slot="{ row }"
            header="Pay type"
          >
            {{ rateType(row.type) }}
          </AppTableColumn>
          <AppTableColumn
            v-slot="{ row }"
            :header="isBillRate ? 'Bill rate' : 'Pay rate'"
          >
            {{ row.rate | currency(organization.currency) }}
          </AppTableColumn>
          <AppTableColumn
            v-slot="{ row }"
            header="Start date"
          >
            {{ columnInformation(row.start_date) }}
          </AppTableColumn>
          <AppTableColumn
            v-slot="{ row }"
            :visible="!isBillRate"
            header="End date"
          >
            {{ columnInformation(row.end_date, 'Present') }}
          </AppTableColumn>
          <AppTableColumn
            v-slot="{ row }"
            header="Updated by"
          >
            {{ columnInformation(row.created_by) }}
          </AppTableColumn>
          <AppTableColumn
            v-slot="{ row }"
            header="Note"
          >
            <span
              v-tooltip
              :title="row.note"
              class="d-block overflow-hidden text-nowrap"
              style="text-overflow: ellipsis; max-width: 120px"
            >
              {{ row.note }}
            </span>
          </AppTableColumn>
        </AppTable>
      </div>
    </div>

    <a
      v-if="moreDataAvailable"
      class="small strong cursor-pointer"
      @click="showMore"
    >
      Show more
    </a>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { kebabCase } from 'lodash-es';
import { MEMBERSHIP_PAY_PERIOD_OPTIONS, MEMBERSHIP_RATE_TYPE_OPTIONS } from '~/app_constants';
import { HUBSTAFF_PEOPLE_BETA } from '~/rails_assets';

import dayjs from 'dayjs';

export default {
  name: 'MembersRatesActivity',
  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
      validator: (v) => ['pay', 'bill'].includes(v),
    },
    wrapperClasses: {
      type: String,
      required: false,
      default: '',
    },
  },
  data: () => ({
    hubstaffBetaImage: HUBSTAFF_PEOPLE_BETA,
  }),
  computed: {
    ...mapState(['organization', 'members_rates_loading']),
    ...mapGetters(['memberRates']),
    activityData() {
      const rates = this.memberRates?.[`${this.type}_rates`];

      if (!rates) { return []; }

      return rates
        .map((item) => ({
          ...item,
          trClasses: [kebabCase(`status${item.status}`)],
        }))
        .sort((a, b) => (dayjs(a.start_date).isAfter(dayjs(b.start_date)) ? -1 : 1));
    },
    isBillRate() {
      return this.type === 'bill';
    },
    moreDataAvailable() {
      // TBD - Pagination
      return false;
    },
    canDelete() {
      // TBD: Allow deletion of item
      return false;
    },
  },
  methods: {
    ...mapActions(['removeActivityItem']),
    columnInformation(data, fallback = '-') {
      return data || fallback;
    },
    isScheduled(status) {
      return status === 'Scheduled';
    },
    payPeriod(period) {
      return MEMBERSHIP_PAY_PERIOD_OPTIONS.find((option) => option.key === period)?.text || '';
    },
    rateType(period) {
      return MEMBERSHIP_RATE_TYPE_OPTIONS.find((option) => option.key === period)?.text || '';
    },
    removeItem(row) {
      // TBD: Allow deletion of item
      // this.removeActivityItem({ id: row.id });
    },
    showMore() {
      // TBD: Pagination
    },
  },
};
</script>
